import React from "react";
import { about } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function About() {
  const ref = useReveal();

  return (
    <section id="about" className="about-meet about-meet-section" ref={ref}>
      <div className="about-meet-inner">
        <h2 className="about-meet-heading" data-reveal>{about.heading}</h2>

        <div className="about-paragraphs" data-reveal>
          {about.paragraphs.map((p, i) => (
            <p className="about-text" key={i}>{p}</p>
          ))}
        </div>

        <ul className="about-credentials" data-reveal>
          {about.credentials.map((c) => (
            <li key={c}>
              <span className="tick">→</span> {c}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
